import { normalizeSocialUrl, SOCIAL_NETWORKS } from '@app/lib'
import { type SugarSocialMedia } from '@app/types'
import { Anchor, Group, ThemeIcon, Tooltip } from '@mantine/core'
import { type FC } from 'react'

export interface SocialMediaIconRowProps {
  values: SugarSocialMedia | undefined
  variant: 'card' | 'compact'
}

export const SocialMediaIconRow: FC<SocialMediaIconRowProps> = ({ values, variant }) => (
  <Group spacing='xs'>
    {SOCIAL_NETWORKS.map(({ network, label, Icon }) => {
      const raw = values?.[network] ?? ''
      const { canonical } = normalizeSocialUrl(network, raw)
      const isSet = canonical !== ''

      if (variant === 'compact') {
        if (!isSet) return null
        return (
          <Tooltip
            key={network}
            label={canonical}
            withinPortal
          >
            <Anchor
              aria-label={`${label} link — opens in new tab`}
              href={canonical}
              rel='noopener noreferrer'
              target='_blank'
            >
              <Icon size={20} />
            </Anchor>
          </Tooltip>
        )
      }

      return (
        <Tooltip
          key={network}
          label={isSet ? canonical : `${label} (not set)`}
          withinPortal
        >
          <ThemeIcon
            aria-label={isSet ? `${label} link set` : `${label} link not set`}
            color={isSet ? 'brand-dark-blue' : 'gray'}
            size='lg'
            variant={isSet ? 'filled' : 'subtle'}
          >
            <Icon size={20} />
          </ThemeIcon>
        </Tooltip>
      )
    })}
  </Group>
)
